import qs from "qs";

export class QueryString {
  private readonly q: qs.ParsedQs;

  static objectToQueryString(
    object: any,
    prependQueryPrefix: boolean = false
  ): string {
    let result = "";
    for (const name of Object.keys(object)) {
      const value = object[name];
      if (value === null || value === undefined || value === "") continue;
      if (result) result += "&";
      result += name + "=" + encodeURIComponent(object[name]);
    }

    if (prependQueryPrefix && result !== "") {
      result = "?" + result;
    }

    return result;
  }

  constructor(search: string) {
    this.q = qs.parse(search, { ignoreQueryPrefix: true });
  }

  getNames(): string[] {
    return Object.keys(this.q);
  }

  toObject(): any {
    const result: any = {};
    for (const name in this.q) {
      if (this.q.hasOwnProperty(name)) {
        result[name] = this.getString(name);
      }
    }
    return result;
  }

  getString(name: string, defaultValue: string | null = null): string | null {
    const value = this.q[name];
    if (typeof value === "string") {
      return value;
    } else {
      return defaultValue;
    }
  }
}
